export default __webpack_public_path__ + "static/media/game-2.fff913c5.PNG";